import React from 'react'
import moment from 'moment';

export const DateData = ({ value }) => (
    <b>
        { moment(value).format('ll') }
    </b>
)
